const LS_KEY = 'trialBarClosed'

export const saveTrialBarCloseToLocalStorage = () => {
  localStorage.setItem(LS_KEY, 'true')
}

export const clearTrialBarCloseFromLocalStorage = () => {
  localStorage.removeItem(LS_KEY)
}

export const isTrialBarAlreadyClosed = (): boolean => {
  return !!localStorage.getItem(LS_KEY)
}
